import React from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';

const NotificationCardModuleStatusUpdateIcon = () => {
  return <ArrowRightOutlined className="text-xl text-pink-500" />;
};

export default NotificationCardModuleStatusUpdateIcon;
